import { render } from "./UserSubMenu.vue?vue&type=template&id=742469c2&ts=true"
import script from "./UserSubMenu.vue?vue&type=script&lang=ts"
export * from "./UserSubMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__